import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { IGeolocationDataResolveData } from './geolocation-data.data';
import { GeolocationDataService } from './geolocation-data.service';
import { LocationInfo } from './models/location-info.model';
import { map } from 'rxjs/operators';

@Injectable()
export class GeolocationDataResolve
  implements Resolve<IGeolocationDataResolveData> {
  static RESOLVE = {
    // key is the same as the RESOLVE_KEY in geolocation-data.data.ts
    geolocationData: GeolocationDataResolve,
  };

  constructor(private _geolocationDataService: GeolocationDataService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IGeolocationDataResolveData> {
    return this._geolocationDataService
      .getLocationInfo()
      .pipe(map((locationInfo: LocationInfo) => ({ locationInfo })));
  }
}
